import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import {  
  GET_CURRENT_TERM_QUERY,
} from "../../graphQL/term_qry";

import { GET_TENANT_DATA_BY_USER } from "../../graphQL/tenant_qry";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import { CREATE_ONBOARDED_MEMBER_MUTATION } from "../../graphQL/member";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },

  termInfoBox: {
  backgroundColor: "#EEF6FF",
  border: "1px solid #CFE2FF",
  borderRadius: 8,
  padding: "14px 18px",
  marginTop: 20,
  marginBottom: 20,
  display: "flex",
  alignItems: "flex-start",
  width: "50%",
},

termInfoText: {
  marginLeft: 12,
  textAlign: "left",
},

}));

function ClientMemberAdd() {
  const [loadContent, setLoadContent] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedStateVal, setSelectedStateVal] = useState("Select");
  const [selectedCountryVal, setSelectedCountryVal] = useState("Select");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedGroupsByClient, setSelectedGroupsByClient] = useState([]);
  const [showAssignGroupDialog, setShowAssignGroupDialog] = useState(false);
  const [tenantStates, setTenantStates] = useState([]);
  const [tenantCountries, setTenantCountries] = useState([]);
  const [linkedinUrl, setLinkedinUrl] = useState("");

  const [termData, setTermData] = useState([]);

  const [getCurrentTermDataQuery] = useManualQuery(GET_CURRENT_TERM_QUERY);

  const [errorMsg, setErrorMsg] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    city: "",
    state: "",
    country:"",
    linkedInURL:""
  });

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");

  const [addAccess, setAddAccess] = useState(true);


  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control
  } = useForm();

  const [createOnboardedMember] = useMutation(CREATE_ONBOARDED_MEMBER_MUTATION);
  
  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });
  
  const getTenant = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      setTenantStates(tenantData.getUserTenantData.statesList.map(({ name }) => name));
      setTenantCountries(
        tenantData.getUserTenantData.countriesList.map(({ name }) => name)
      );
    }
    if (tenantDataError) {
      console.log(tenantDataError);
      if (
        tenantDataError.graphQLErrors &&
        tenantDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  const getCurrentTermData = async () => {
    const {
      loading: loadingCurrentTermData,
      error: errorCurrentTermData,
      data: dataCurrentTermData,
    } = await getCurrentTermDataQuery({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (
      !loadingCurrentTermData &&
      dataCurrentTermData &&
      dataCurrentTermData.getCurrentTerm
    ) {
      setTermData(dataCurrentTermData.getCurrentTerm);
      
    }
    
  };  
  
  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Members",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Add")){
        setAddAccess(true); }
      else { setAddAccess(false); }
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenant())();
  }, []); 

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getCurrentTermData())();
  }, [clientId]);

  const handleLinkedInChange = e => {
    let newVal = e.target.value;
    setLinkedinUrl(newVal);    
  };

  const openLinkedIn = () => {
    if (!linkedinUrl?.trim()) return;

    let url = linkedinUrl.trim();

    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    try {
      const parsedUrl = new URL(url);

      if (!parsedUrl.hostname.includes("linkedin.com")) {
        alert("Please enter a valid LinkedIn URL.");
        return;
      }

      window.open(parsedUrl.href, "_blank", "noopener,noreferrer");
    } catch {
      alert("Please enter a valid URL.");
    }
  };

  const onSubmit = async formData => {
   
   const { data, error } = await createOnboardedMember({
      variables: {
        email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNo: formData.phoneNo,
          city: formData.city,
          state: formData.state,
          country: formData.country,
          linkedinUrl: formData.linkedinUrl,
          termId: parseInt(termData.termId)
      },
    });
    if (error) {
      if (error.graphQLErrors[0].message == "RepeatedEmail")
      {
        setErrorMsg({ email: "This email address exists. Please try another email." });
      }
      else
      {
        console.log("Error", error, data);
        setAlertMsg({
            title: "Error",
            msg: error.graphQLErrors[0].message,
          });
      }
      
    } else if (data && data.createOnboardedMember) {
      console.log("Success", data);
      setAlertMsg({
        title: "Success",
        msg: "New onboarded member has been successfully added.",
      });
    }
  };
  
  if (loadContent)
    if (addAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Add Onboarded Member", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Add Onboarded Member
            </Typography>
          </Box>
          <Divider />

          <Box className={classes.termInfoBox}>
            <InfoOutlinedIcon
              style={{
                color: "#1976d2",
                marginTop: 2,
              }}
            />

            <Box className={classes.termInfoText}>
              <Typography
                variant="body2"
                style={{ fontWeight: 600 }}
              >
                Term Onboarded:&nbsp;
                {termData?.name}
                {" ("}
                {dayjs(termData?.startDate).format("MMM D, YYYY")}
                {" - "}
                {dayjs(termData?.endDate).format("MMM D, YYYY")}
                {") "}
                (Current Term)
              </Typography>

              <Typography
                variant="body2"
                style={{
                  color: "#555",
                  marginTop: 4,
                }}
              >
                Members can be onboarded only in the current term.
              </Typography>
            </Box>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              style={{
                marginTop: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              
              
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="First Name *"
                  margin="normal"
                  name="firstName"
                  type="name"
                  variant="outlined"
                  id="firstName"
                  {...register("firstName", { required: true })}
                />

                {errors.firstName && errors.firstName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    First name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.firstName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.firstName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Last Name *"
                  margin="normal"
                  name="name"
                  type="name"
                  variant="outlined"
                  id="lastName"
                  {...register("lastName", { required: true })}
                />

                {errors.lastName && errors.lastName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Last name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.lastName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.lastName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Email *"
                  margin="normal"
                  name="email"
                  type="email"
                  variant="outlined"
                  id="email"
                  {...register("email", {
                    required: true,
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  })}
                />

                {errors.email && errors.email.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Email cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.email && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.email}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="LinkedIn URL *"
                    margin="normal"
                    name="linkedinUrl"
                    type="text"
                    variant="outlined"                    
                    id="linkedinUrl"
                    {...register("linkedinUrl", { required: true })}
                    onChange={handleLinkedInChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={openLinkedIn}
                            disabled={!linkedinUrl || !linkedinUrl.trim()}
                            title={
                              linkedinUrl && linkedinUrl.trim()
                                ? "View LinkedIn page"
                                : "Enter a LinkedIn URL"
                            }
                          >
                            <OpenInNewIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    />

                    {errors.linkedinUrl && errors.linkedinUrl.type === "required" && (
                      <FormHelperText className={classes.errorStyle} error>
                        LinkedIn URL cannot be blank.
                      </FormHelperText>
                    )}                    

                    {errorMsg.linkedinUrl && (
                      <FormHelperText className={classes.errorStyle} error>
                        {errorMsg.linkedinUrl}
                      </FormHelperText>
                    )}
                  </Grid>

              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Phone Number *"
                  margin="normal"
                  name="phoneNo"
                  type="text"
                  variant="outlined"
                  id="phoneNo"
                  {...register("phoneNo", { required: true })}
                />

                {errors.phoneNo && errors.phoneNo.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Phone number cannot be blank.
                  </FormHelperText>
                )}
                {errorMsg.phoneNo && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.phoneNo}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="City *"
                  margin="normal"
                  name="city"
                  type="text"
                  variant="outlined"
                  id="city"
                  {...register("city", { required: true })}
                />

                {errors.city && errors.city.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    City cannot be blank.
                  </FormHelperText>
                )}
                {errorMsg.city && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.city}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  className={classes.autoComStyle}
                  key={selectedStateVal}
                  options={tenantStates}
                  PopperComponent={PopperMy}
                  getOptionLabel={option => option}
                  renderInput={params => (
                    <TextField
                      fullWidth
                      label="State *"
                      margin="normal"
                      name="selectState"
                      variant="outlined"
                      {...params}
                      id="state"
                      {...register("state", { required: true,})}
                    />
                  )}
                />              
              {errors.state && errors.state.type === "required" && (
                <FormHelperText
                  style={{
                    width: 300,                    
                  }}
                  className={classes.errorStyle} error>
                  One item must be selected.
                </FormHelperText>
              )}
              </Grid>
              <Grid item xs={4}>
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    key={selectedCountryVal}
                    options={tenantCountries}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => option}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        label="Country *"
                        margin="normal"
                        name="selectCountry"
                        variant="outlined"
                        {...params}
                        id="country"
                        {...register("country", { required: true,})}
                    />
                  )}
                />              
              {errors.country && errors.country.type === "required" && (
                <FormHelperText
                  style={{
                    width: 300,                    
                  }}
                  className={classes.errorStyle} error>
                  One item must be selected.
                </FormHelperText>
              )}
                </form>
              </Grid>
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/members`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/members`);
              }}
            />
          )}
          
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ClientMemberAdd;
